'use client';

import { create } from 'zustand';
import type { Language } from './types';

export type LanguageAlternates = Partial<Record<Language, string>>;

interface LanguageAlternatesState {
  alternates: LanguageAlternates | null;
  setAlternates: (alternates: LanguageAlternates | null) => void;
}

// WHY: переключатель языка по умолчанию меняет только префикс адреса; страница, у которой адреса переводов
// различаются (новость со своим slug на каждом языке), кладёт сюда точные адреса — иначе смена языка открыла бы чужую статью
export const useLanguageAlternatesStore = create<LanguageAlternatesState>()((set) => ({
  alternates: null,
  setAlternates: (alternates) => set({ alternates }),
}));

export const languageSwitchTarget = (code: Language, alternates: LanguageAlternates | null, fallback: string): string =>
  alternates?.[code] ?? fallback;
